import React, {Component} from 'react';
import '../../App.css';
// import {TableColumnPopupType} from '../Popup/TableColumnPopup';
// import { getLocalisedText } from '../../Translate/LanguageManager';
// import AppManager from '../../Manager/AppManager';
// import Utility from '../../Utilities/Utility';

import {
    Utility,
    AppManager,
    getLocalisedText,
    TableColumnPopupType
} from 'deskera-doc-builder-lib';
export default class JournalEntryColumnEditor extends Component {

    dataChanged(data) {
        this.props.dataChanged(this.props.data);
    }

    render() {
        return this.getJournalEntryColumns(this.props.columnData)
    }

    getJournalEntryColumns(columnsData = []) {
        var arr = [];
        for (let i = 0; i < columnsData.length; i++) {
            arr.push(this.getJournalEntryColumn(i, columnsData[i]));
        }
        return arr;
    }

    getJournalEntryColumn(index, columnData) {
        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    width: "100%",
                    alignItems: "flex-start",
                }}
            >
                {this.getShowHideValueForTablePopup(TableColumnPopupType.date) && this.getColumnTextfields(
                    "date",
                    index,
                    columnData.date,
                    this.columnDateChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.journalEntryNumber) && this.getColumnTextfields(
                    "journal_entry_number",
                    index,
                    columnData.journalEntryNumber,
                    this.columnJournalEntryNumberChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.accountName) && this.getColumnTextfields(
                    "account_name",
                    index,
                    columnData.accountName,
                    this.columnAccountNameChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.accountCode) && this.getColumnTextfields(
                    "account_code",
                    index,
                    columnData.accountCode,
                    this.columnAccountCodeChanged
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.description) && this.getColumnTextfields(
                    "description",
                    index,
                    columnData.description,
                    this.columnDescriptionChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.credit) && this.getColumnTextfields(
                    "credit",
                    index,
                    columnData.credit,
                    this.columnCreditChanged,
                )}
                {this.getShowHideValueForTablePopup(TableColumnPopupType.debit) && this.getColumnTextfields(
                    "debit",
                    index,
                    columnData.debit,
                    this.columnDebitChanged,
                )}

                <div className='RowDiv'
                    style={{
                        flexDirection: Utility.getIsArabicLang() ? 'row-reverse' : 'row'
                    }}>
                    <button
                        style={{
                            marginTop: 10,
                            cursor: "pointer",
                            color: "red",
                            border: "solid",
                            borderWidth: 1,
                            borderColor: "rgb(210, 210, 210)",
                            backgroundColor: "white",
                            borderRadius: 4,
                            marginBottom: 20,
                        }}
                        onClick={() => this.deleteColumn(index)}
                    >
                        {getLocalisedText("delete")}
                    </button>
                </div>
            </div>
        );
    }

    deleteColumn(index) {
        var data = this.props.data;
        data["lineItems"].splice(index, 1);
        this.dataChanged(data);
    }

    getColumnTextfields(placeholder, index, value, callback) {
        return (
            <input
                className="TextField"
                style={{
                    marginTop: 6,
                    borderRadius: 4,
                    color: 'rgb(30, 30, 30)'
                }}
                placeholder={getLocalisedText(placeholder)}
                type="text"
                dir={Utility.getInputDirection()}
                value={getLocalisedText(value)}
                onChange={(e) => callback(e, index)}
            />
        );
    }

    columnDateChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["date"] = event.target.value;
        this.dataChanged(data);
    };

    columnAccountNameChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["accountName"] = event.target.value;
        this.dataChanged(data);
    };

    columnAccountCodeChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["accountCode"] = event.target.value;
        this.dataChanged(data);
    };

    columnDescriptionChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["description"] = event.target.value;
        this.dataChanged(data);
    };

    columnJournalEntryNumberChanged = (event, index) => {
        var data = this.props.data;
        data["lineItems"][index]["journalEntryNumber"] = event.target.value;
        this.dataChanged(data);
    };

    columnCreditChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["credit"] = value;
        this.dataChanged(data);
    };

    columnDebitChanged = (event, index) => {
        let value = event.target.value
        if (isNaN(value)) {
            return
        }
        var data = this.props.data;
        data["lineItems"][index]["debit"] = value;
        this.dataChanged(data);
    };

    getShowHideValueForTablePopup(tableColumnPopupType) {
        var item = AppManager.getTableColumnOptions(this.props.data.tableColumnPopup, tableColumnPopupType)
        if(item === undefined || item  === null) {
            return false
        }
        else {
            return item.isSelected
        }
    }

}
